import { useQuery } from '@tanstack/react-query';
import { useSite } from '../../../context/page-context';
import { useBillingApi } from './use-billing-api';

const QK_AVAILABLE_PLANS = (siteId: string) => ['billing', 'available-plans', siteId] as const;

export function useAvailablePlans() {
  const { billingApi } = useBillingApi();
  const { siteId } = useSite();

  return useQuery({
    queryKey: QK_AVAILABLE_PLANS(siteId),
    queryFn: () => billingApi.availablePlans(siteId),
  });
}
